import axios from 'axios';
import { BASE_API } from '../../helpers/base'
import {getBtoa} from "../../services/util";

const state = {
    userDetails: [],
    token: localStorage.getItem('token'),
    appHash: localStorage.getItem('expired'),
    isAuthenticated: false,
    status: ''
  }

  const mutations = {
    is_authenticated(state, {bool, token, user, expired}){
        state.isAuthenticated = bool
        state.token = token
        state.appHash = expired
        state.userDetails = user
        state.status = 'logged in'
    },
    auth_request(state){
        state.status = 'loading'
    },
    auth_error(state){
        state.status = 'error'
    },
    logout(state){
        state.status = ''
        state.userDetails = ''
        state.token = ''
    },
    set_user_details(state, detail) {
        state.userDetails = detail;
    },
    update_user_details(state, detail){
        state.userDetails.unshift(detail);
    }
  }

const actions = {
    checkCode({commit}, code){
      return new Promise((resolve, reject) => {
        axios({url: `${BASE_API}/verify-code`, data: code, method: 'POST' })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    login({commit}, user){
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: `${BASE_API}/connexion`, data: user, method: 'POST' })
            .then(resp => {
                const token = resp.data.user_info.token
                const userData = resp.data.user_info
                const expired = getBtoa(userData.id)
                if(token){
                    commit('is_authenticated', {bool:true, token:token, user:userData, expired:expired})
                    commit('set_user_details', userData)
                    localStorage.setItem('token', token)
                    localStorage.setItem('userId', userData.id)
                    localStorage.setItem('expired', expired)
                    axios.defaults.headers.common['Authorization'] = token
                }else{
                    console.log(resp)
                    commit('auth_error')
                }
                resolve(resp)
            })
            .catch(err => {
                commit('auth_error', err)
                localStorage.removeItem('token')
                reject(err)
            })
        })
    },
    register({commit}, user){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios({url: `${BASE_API}/register`, data: user, method: 'POST' })
          .then(resp => {
            const token = resp.data.user_info.token
            const userData = resp.data.user_info
            const expired = getBtoa(userData.id)
            if(token){
                commit('is_authenticated', {bool:true, token:token, user:userData, expired:expired})
                localStorage.setItem('token', token)
                localStorage.setItem('userId', userData.id)
                localStorage.setItem('expired', expired)
                axios.defaults.headers.common['Authorization'] = token
                console.log(resp)
            }else{
                console.log(resp)
                commit('auth_error')
            }
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error', err)
            localStorage.removeItem('token')
            reject(err)
          })
        })
    },
    logout({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('userId')
            // remove the axios default header
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },
    setUserDetails: ({commit}, detail) => {
        commit('set_user_details', detail)
    },
    updateUserDetails: ({commit}, detail) => {
        commit('update_user_details', detail)
    }
}

  const getters = {
    currentUser(state) {
        return state.userDetails
    },
    isLoggedIn(state) {
        let hash =  localStorage.getItem('userId')
        return (state.token && getBtoa(hash) == state.appHash);
    },
    statusMessage(state){
        return state.status
    }
  }

  export default {
    state,
    mutations,
    actions,
    getters
  }



// WEBPACK FOOTER //
// ./src/store/modules/User.store.js